import { createNodeDef } from "../nodes.helpers";

export const objectNodeDef = createNodeDef({
  type: "object",
  displayName: "Object",
  description: "An object with all child nodes as properties",
  acceptsChildren: true,
  initialData: () => ({}),
  generate: async ({ children }) => {
    const result = {};

    for await (const { value, childTreeNode } of children.loop()) {
      Object.assign(result, { [childTreeNode.node.name]: value });
    }

    return result;
  },
});
